import { Crown } from "lucide-react";

export default function Marquee({ text }) {
  const phrase = text || "3 YEARS TO 50 YEARS — EVERYONE IS ROYALTY — ";
  return (
    <div
      data-testid="marquee-ribbon"
      className="relative overflow-hidden border-y border-[#D4AF37]/25 bg-[#0A0A0A] py-5"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[...Array(8)].map((_, i) => (
          <span
            key={i}
            className="font-display flex items-center text-lg tracking-[0.3em] text-[#D4AF37]/75 md:text-xl"
          >
            {phrase}
            <Crown className="mx-8 h-4 w-4 shrink-0" strokeWidth={1} />
          </span>
        ))}
      </div>
    </div>
  );
}
